<template lang="pug">
#vendor-select
  v-autocomplete.vendor-selector(
    v-model="select",
    solo,
    dense,
    hide-details,
    outlined,
    clearable,
    return-object,
    item-text="name",
    :items="items",
    :placeholder="$t('Placeholder.__Vendor')",
    @click:clear="clearAction"
  )
    template(v-if="insertTag", v-slot:append-item)
      v-divider
      v-list-item.text-left(@click="newVendorDialog = true")
        v-list-item-avatar
          v-icon add
        v-list-item-content
          v-list-item-title {{ $t('Vendors.__AddVendor') }}

  NewVendorDialog(v-model="newVendorDialog", :done-action="insertDoneAction")
</template>
<script>
// test data
// import vendorsJSON from "@/test/data/vendors.json";
import NewVendorDialog from "@/components/dialogs/NewVendorDialog"

export default {
  components: { NewVendorDialog },
  props: {
    value: {
      type: Object
    },
    insertTag: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      newVendorDialog: false,
      search: null,
      items: [],
      select: null,
      vendors: []
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    }
  },
  methods: {
    clearAction() {
      this.$emit("input", null)
    },
    getVendors() {
      this.$store
        .dispatch("vendors/getVendors", {
          pageNumber: 1,
          pageSize: 999
        })
        .then(
          function(response) {
            this.items = this.vendors = response.data
            if (this.name != null) {
              this.select = this.vendors.find(item => {
                return item.name == this.name
              })
            }
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    insertDoneAction(vendorId) {
      this.getVendors()
      this.$store.dispatch("vendors/getVendor", vendorId).then(response => {
        this.select = response.data
      })
    },
    querySelections(val) {
      this.items = this.vendors.filter(item => {
        return (
          (item.name || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1 ||
          (item.code || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1
        )
      })
    }
  },
  mounted() {
    this.getVendors()
    this.select = this.value
  }
}
</script>
